let vi = {
  "common": {
    //Phần dịch chung
    "returnButton": "Quay lại",
    "okButton": "OK",
  },
  //Trang chủ
  "home": {
    "myLesson": "Khóa học của tôi",
    "learningAnalysis": "Tình hình học tập",
    "courseConditions": "Tình trạng khoá học",
    "learningProcess": "Tiến độ học tập",
    "performanceAnalysis": "Thành tích học tập",
    "liveMessage": "Khoá học online",
    "notLogin": "Đăng nhập",
    "faceIn": "Đăng nhập bằng cách nhận dạng khuôn mặt",
    "accountIn": "Tài khoản",
    "accountOrEmail": "Email/UserID",
    "passwordDigits": "Mật khẩu",
    "rememberMe": "Nhớ mật khẩu",
    "forgetPass": "Nếu bạn quên mật khẩu, Vui lòng nhấp vào đây",
    "identifyStart": "Bắt đầu xác thực",
    "immediateLogin": "Đăng nhập",
    "courseName": "Tên khóa học",
    "teachingTime": "Ngày giảng",
    "status": "Trạng thái",
    "clickJump": "Tham gia",
    "userProtocol": "《Chính sách bảo mật》",
    "operation": "Hướng dẫn thao tác",
    "faq": "Câu hỏi thường gặp",
    "service": "Điều khoản sử dụng dịch vụ",
    "policy": "Chính sách bảo mật",
    "keepLogin": "Duy trì đăng nhập",
    "support": "Hỗ trợ",
    "schcourseConditions": "Tình trạng khoá học (Lịch trình)", 		 
	  "schperformanceAnalysis": "Thành tích học tập (Lịch trình)",
    "welcome": "Chào mừng bạn đến với Study-arts!",
    "selectCompanyTitle": "Hãy chọn công ty mà bạn muốn đăng nhập vào.",
  },
  //Lỗi hiển thị hình ảnh
  "err": {
    "err1": "Có lỗi trong quá trình chuyển đổi hình ảnh.",
    "err2": "Hãy đăng xuất một lần, đóng trình duyệt và thử lại sau một thời gian.",
    "err3": "Thêm vào đó, nếu sai sót không được giải quyết, hãy tham khảo ý kiến của trung tâm hỗ trợ StudyArts.",
    "err4": "Đã xảy ra lỗi trong quá trình truy cập dữ liệu. Vui lòng liên hệ với đội ngũ Study Arts để được hỗ trợ",
    "revertErr": "Về trang chủ",
  },
  //Trạng thái học chi tiết
  "aicourse": {
    "beginLearn": "Bắt đầu",
    "endLearn": "Kết thúc",
    "timeLength": "Kỳ hạn",
    "week": "Tuần",
    "weekPlan": "Tuần",
    "hoursPre": "Thời gian dự định",
    "beforeKnowledge": "Kiến thức bắt buộc",
    "distinguish": "Phân loại",
    "courseLanguage": "Ngôn ngữ",
    "classification": "Phân loại",
    "category": "Danh mục"
  },
  //
  "courseScoreStatistics": {
    "beginLearningTime": "Thời gian bắt đầu học",
    "validityPeriod": "Thời gian hiệu lực của khóa học",
  },
  //community
  "community": {
    "content": "Không có thông tin",
    "dataNone": "Không có câu trả lời nào sai.",
    "down": "Tải xuống",
  },
  //Phân tích thành tích
  "scoreStatistics": {
    "performanceAnalysis": "Thành tích học tập",
    "schPerformanceAnalysis":"Thành tích học tập(Lịch trình)",
    "courseName": "Khóa học",
    "courseNameInput": "Vui lòng nhập tên khóa học.",
    "validityPeriod": "Thời gian hiệu lực của khóa học",
    "chooseDate": "Chọn ngày",
    "search": "Tìm kiếm",
    "studentsCounst": "Số lượng học viên",
    "myScore": "Điểm hiện tại",
    "aveScore": "Điểm trung bình",
    "maxPoint": "Điểm cao  nhất",
    "minPoint": "Điểm thấp nhất",
    "point90": "Đậu",
    "point80": "Không đậu",
    "personCount": "Số người",
    "proportion": "Tỷ lệ",
    "passPercent": "Điểm chuẩn",
    "judge": "Đánh giá",
    "message1": "Điểm thi cao nhất : ",
    "message2": "Điểm",
    "message3": "※Course platform không phải là đối tượng phân tích thành tích",
    "result": "Kết quả",
    "testName": "Tên kì thi",
    "finalExam": "Thi cuối kì",
  },
  "curriculum": {
    "exam": "Bài thi cuối kỳ",
    "errorCollection": "Câu hỏi trả lời không chính xác",
    "questionnaire": "Câu hỏi khảo sát",
    "scoreStatistics": "Thành tích",
    "gotoLive": "Bài giảng Trực tiếp",
    "question": "Bảng khảo sát",
    "covenant": "Bản cam kết",
    "thi__giua__ki": "Thi giữa kì"
  },
  "curriculumExam": {
    "listExam": "Danh sách bài thi",
    "passExam": "Bài đã đậu",
    "failExam": "Bài không đậu",
    "doNotExam": "Bài chưa làm",
    "rank": "Bảng xếp hạng",
    "doingExam": "Bạn không thể kiểm tra kết quả khi đang tham gia thi"
  },
  //Trang bắt đầu bài thi
  "examBegins": {
    "center": "Examination Center",
    "notice": "Lưu ý về kỳ thi",
    "introduce": "Giải thích kì thi",
    "first": "Kỳ thi này nhằm xác nhận sự hiểu biết của bạn về những gì đã học được trong khóa học đã tham gia.",
    "second": "Dạng đáp án cho kỳ thi là trắc nghiệm (chọn một đáp án, chọn nhiều đáp án), điền từ vào chỗ trống, tự luận, v.v.",
    "third": "Bài kiểm tra này phải là bài kiểm tra cuối cùng sau khi tất cả các bài kiểm tra nhanh trong mỗi chương đã được hoàn thành. Vui lòng hoàn thành tất cả các câu hỏi trong các bài kiểm tra nhanh trước khi làm bài kiểm tra.",
    "rule": "Quy tắc kiểm tra",
    "one": "Vui lòng trả lời tất cả các câu hỏi trong thời gian qui định. Kỳ thi sẽ tự động kết thúc khi hết thời gian.",
    "two": "Nếu không có câu trả lời thì sẽ đánh giá là trả lời sai.",
    "three": "Sau khi trả lời hết các câu hỏi, bạn vui lòng kiểm tra lại các câu trả lời đã chính xác chưa và bấm nút“ Gửi ”để kết thúc bài thi. ",
    "remain": "Số lần dự thi",
    "current": "Điểm số cuối cùng",
    "highest": "Điểm cao nhất",
    "begin": "Bắt đầu kiểm tra",
    "giveUp": "Hủy",
    "notice_exam": "Lưu ý về kỳ thi cuối kỳ",
    "notice_midterm": "Lưu ý về kỳ thi giữa kỳ",
    "type": "Loại hiển thị",
    "notFull": "Hiển thị từng câu",
    "full": "Hiển thị toàn bộ",
    "changeTypeShow": "Đổi kiểu hiển thị"
  },
  "examResume": {
    "resume": "Lịch sử dự thi",
    "point": "Điểm đạt được",
    "time": "Ngày dự thi",
    "jump": "Chuyển đến trang lớp học",
  },
  "detailExam": {
    "finalExam": "Thi Cuối Kì",
    "seconds": " Giây",
    "minutes": " Phút",
    "fullMark": "Điểm Tối Đa",
    "standardMark": "Điểm Chuẩn",
    "yourMark": "Điểm Của Bạn",
    "pass": "Đậu",
    "fail": "Không Đậu",
    "viewDetailWrong": "Xem Chi Tiết Câu Sai",
    "viewChapter": "Điểm Từng Hạng Mục Đạt Được",
    "totalRightAnswer": "Số Câu Đúng",
    "totalScore": "Điểm Đạt Được"
  },
  //Câu trả lời không chính xác
  "errorBook": {
    "errorBook": "Câu trả lời không chính xác",
    "prve": "Về trước",
    "next": "Đi tiếp",
    "answerInput": "Vui lòng nhập câu trả lời của bạn ...",
    "answer": "Đáp án học viên",
    "rightAnswer": "Câu trả lời",
    "answerAnalysis": "Phân tích câu trả lời",
    "download": "Xuất danh sách",
    "remove": "Xóa khỏi danh sách",
    "confirmMessage": "Bạn có chắc là muốn xóa ra khỏi danh sách câu trả lời sai không",
  },
  "active": {
    "goHome": "Quay lại trang đầu",
  },
  "previewBook":{
    "previewBook": "Xem trước câu hỏi kì thi cuối kỳ",
  },
  //
  "email": {
    "title": "Khôi phục mật khẩu",
    "email": "Vui lòng nhập địa chỉ email đã đăng ký cho tài khoản của bạn.",
    "emailWarning": "※ Đối với khách hàng sử dụng ID người dùng để sử dụng hệ thống này, chức năng này không thể sử dụng được. Nếu bạn muốn đặt lại mật khẩu, vui lòng liên hệ với người quản lý cấp ID người dùng của bạn.",
    "placeholder": "Nhập địa chỉ email của bạn.",
    "confirmplaceholder": "Nhập địa chỉ email của bạn (xác nhận)",
    "confirm": "Gửi",
    "message": "Địa chỉ email bạn đã nhập không đúng.",
  },
  "register_email": {
    "title": "Khôi phục mật khẩu",
    "message": "Hệ thống vừa gửi email cho bạn qua email đã đăng ký cho tài khoản. Vui lòng làm theo hướng dẫn trong email để khôi phục mật khẩu.",
    "passwordResetSuccess": " Mật khẩu đã được đặt lại. Vui lòng đăng nhập lại.",
    "timeout": "Thời hạn hiệu lực của URL cài đặt lại đã hết. Sẽ mất một ít thời gian, nhưng xin hãy gửi lại mail cài đặt lại 1 lần nữa từ [Bạn quên mật khẩu?] ở màn hình đăng nhập.",
    "checkMessage": "Password không thống nhất",
  },
  "courseList": {
    "courseName": "Tên khóa học",
    "courseNameInput": "Vui lòng nhập tên khóa học.",
    "validityPeriod": "Thời gian hiệu lực của khóa học",
    "chooseDate": "Chọn ngày",
    "to": "～",
    "no": "No.",
    "operation": "Thao tác",
  },
  "courseProgress": {
    "learningProcess": "Tiến độ",
    "search": "Tìm kiếm",
    "learnBeginDate": "Ngày bắt đầu học",
    "complete": "Số chương",
    "uncomplete": "Số chương chưa hoàn thành",
    "examhistory": "Xem lịch sử dự thi",
    "isquestion": "Bảng khảo sát",
    "look": "Hiển thị",
  },
  "personSet": {
    "changePass": "Đổi mật khẩu",
    "personInfo": "Thông tin cá nhân",
    "messageCenter": "Trung tâm Thông tin",
    "changeFace": "Cập nhập ảnh đại diện",
    "chooseImg": "Lựa chọn hình ảnh",
    "save": "Lưu",
    "off": "Hủy",
    "confirm": "Lưu mật khẩu",
    "currentPass": "Mật khẩu hiện tại",
    "newPass": "Mật khẩu mới",
    "repeatPass": "Mật khẩu mới (Xác nhận)",
    "notMessage": "Không có tin nhắn",
    "noticeTime": "Thời gian thông báo",
    "noticeTittle": "Nội dung thông báo",
    "status": "Trạng thái",
    "unread": "Chưa đọc",
    "read": "Đã đọc",
    "userName": "Tên người dùng",
    "email": "E-mail",
    "mobile": "điện thoại di động",
    "change": "OK",
    "passwordNotNull": "Bắt buộc nhập mật khẩu mới.",
    "oldPasswordIncorrect": "Mật khẩu hiện tại không chính xác.",
    "passwordChangeFail": "Không thể thay đổi mật khẩu.",
    "imgSuccess": "Đã chỉnh sửa ảnh hồ sơ.",
    "placeholder": "Nhập 8-16 ký tự viết hoa, thường và số.",
    "defaultLanguage": "Ngôn ngữ",
    "imageError": "File hình bạn chọn không được hỗ trợ（gif,jpeg,jpg,png,bmp）",
    "birthday":"Sinh nhật",
    "occupation":"Nghề nghiệp",
    "synopsisUser": "Giới thiệu bản thân",
    "synopsisNonUser": "Bạn chưa giới thiệu bản thân.",
    "enterName": "Vui lòng nhập tên.",
    "editInfoUser": "CHỈNH SỬA THÔNG TIN CÁ NHÂN",
    "enterSex": "Lựa chọn giới tính.",
    "enterMobile": "Vui lòng nhập thông tin liên lạc.",
    "enterJob": "Vui lòng nhập nghề nghiệp.",
    "enterSynopsis": "Vui lòng nhập thông tin giới thiệu.",
    "personInfoSanritsu": "Thông tin cá nhân"
  },
  "contactUs": {
    "contactUs": "Liên hệ với chúng tôi",
    "email": "địa chỉ mail",
    "send": "Gửi",
    "problem": "Vui lòng nhập câu hỏi của bạn",
    "sucess": "Gởi.",
    "sure": "Mả số xác nhận",
    "sorry": "Chúng tôi rất sẵn lòng trả lời câu hỏi của bạn và chúng tôi xin lỗi nếu bất kỳ sản phẩm và dịch vụ nào của chúng tôi gây ra bất tiện cho bạn.",
    "gohome": "Quay lại trang đầu",
    "faild": "không thể gửi.",
    "sever": "Máy chủ hiện đang bận. Vui lòng thử lại sau.",
    "resend": "gửi lại",
  },
  //Trang danh sách khóa học
  "schoolBusiness": {
    "sloganFour": "Khoá học của tôi",
    "all": "Tất cả",
    "introduceThree": "Don't miss out on business",
    "introduceFour": "Enroll in a course and build your best future, today.",
    "beginLearn": "Về đầu trang",
    "elective": "Tự chọn",
    "generalCourse": "Khóa học chung",
    "privateCourse": "Khóa học riêng",
  },
  "search": {
    "keyWord": "Vui lòng nhập từ khóa",
    "result": "Không có kết quả tìm kiếm",
  },
  "studySituationList": {
    "count": "Tình trạng khóa học tham gia",
    "validityPeriodStart": "Thời gian bắt đầu",
    "validityPeriodEnd": "Thời gian kết thúc",
    "distinguish": "Loại",
    "studentEndDate": "Hoàn thành bài học",
    "guarantee": "Bản cam kết",
    "certificate": "Chứng chỉ",
    "notRaised": "Chưa gửi",
    "raised": "Đã gửi",
  },
  "schStudySituationList": {
    "count":"Tình trạng khóa học tham gia(Lịch trình)",
    "validityPeriodStart": "Thời gian bắt đầu",
    "validityPeriodEnd": "Thời gian kết thúc",
    "learnBeginDate": "Ngày bắt đầu học",
    "learnEndDate": "Ngày kết thúc học",
    "learningProcess":"Tiến độ học tập",
    "completionStatusFlag":"Trạng thái hoàn thành",
    "offlineCompleteTime":"Ngày hoàn thành",
    "isDelay":"Trì hoãn",
    "finish": "Hoàn thành",
    "undone": "Chưa hoàn thành",   
    "delay": "Có trì hoãn",
    "noDelay": "Không có trì hoãn",   
  },
  "task_answer": {
    "answerCommit": "Chấm bài",
    "examCommit": "Nộp bài",
    "answer": "Đáp án",
  },
  "task_result": {
    "prev": "Về trước",
    "next": "Đi tiếp",
    "wrong": "Trả lời chưa chính xác",
    "reght": "Trả lời chính xác",
    "answer": "Đáp án",
    "analysis": "Phân tích câu hỏi",
    "question": "Câu",
    "unShowAnswer": "Bạn không thể xem đáp án câu này",
  },
  "rePassword": {
    "newPassword": "(8-16 bit) Mật khẩu mới",
    "repeact": "(8-16 bit) Xác nhận mật khẩu",
    "confirm": "Xác nhận",
  },
  "read": {
    "catalogue": "Mục lục",
    "note": "Ghi chú",
    "chat": "Trao đổi",
    "tips": "Viết ghi chú về khóa học này tại đây.",
    "login": "Vui lòng đăng nhập.",
    "save": "Lưu",
    "jump": "Thứ .",
    "page": "Đi tới trang",
    "prev": "Về trước",
    "next": "Đi tiếp",
    "returnCatalogue": "Tới mục lục"
  },
  "week": {
    "status": "Trạng thái",
    "exercise": "Bài tập",
    "score": "Tỷ lệ điểm",
    "undone": "Chưa học",
    "done": "Đã học xong",
    "studing": "Đang học"
  },
  "questionnaire": {
    "questionnaire": "Bảng câu hỏi khảo sát",
    "contentInput": "Vui lòng nhập nội dung.",
    "submit": "Gửi đi",
    "tempSave": "Lưu tạm",
    "tempSaveHint1": "Bạn có muốn thực hiện lưu tạm thời kết quả khảo sát?",
    "tempSaveHint2": "Lưu ý: Dữ liệu sẽ không được lưu nếu bạn chuyển đổi trình duyệt hoặc thiết bị.",
    "noticeSuccess": "Lưu thành công.",
  },
  "js": {
    "confirm": "OK",
    "quite": "Bạn có muốn đăng xuất không?",
    "hint": "Xác nhận",
    "cancel": "Hủy",
    "userNameNull": "Tên người dùng là mục nhập bắt buộc.",
    "email": "Vui lòng nhập địa chỉ email của bạn.",
    "formatWrong": "Địa chỉ email không chính xác.",
    "passwordNull": "Vui lòng nhập thông tin mật khẩu.",
    "passwordFormat": "Vui lòng nhập mật khẩu từ 8 đến 16 chữ số là hỗn hợp của chữ hoa, chữ thường và số.※ Ngoại trừ các ký tự đặc biệt như 「_ + - = * #% $」.",
    "repeatPassword": "Xác nhận mật khẩu là mục nhập bắt buộc.",
    "different": "Mật khẩu không đúng.",
    "service": "Bạn có chắc chắn muốn gửi bản cam kết không?",
    "account": "Vui lòng điền thông tin tài khoản của bạn",
    "password": "Vui lòng nhập thông tin mật khẩu.",
    "beginLearning": "Bạn có chắc chắn muốn bắt đầu không? ",
    "dataNone": "Không có thông tin",
    "jumpToexam": "Vui lòng tham gia“ kỳ thi cuối khóa ”sau khi hoàn thành tất cả nội dung học. ",
    "examDataNone": "Không có thông tin về kỳ thi",
    "certificateDataNone": "Thông tin Giấy chứng nhận hoàn thành chưa được đăng ký",
    "jumpToQuestion": "Vui lòng trả lời“ bảng câu hỏi ”sau khi tham gia“ kỳ thi cuối khóa ”. ",
    "jumpToErrorBook": "Vui lòng sử dụng” Câu hỏi hay sai ”sau khi hoàn thành khóa học. ",
    "loginPlease": "Vui lòng đăng nhập.",
    "lastExam": "Bạn không thể làm lại bài thi khi đang chấm điểm bài thi. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn tất.",
    "no": "Số",
    "placeholder": "Điền vào đây",
    "examOver": "Thời gian làm bài thi đã hết. Các câu hỏi trả lời trước thời hạn sẽ được gửi tự động.",
    "emailNone": "Địa chỉ email không tồn tại.",
    "sendSuccess": "Đã gởi.",
    "returnHome": "Quay lại trang đầu",
    "problemInput": "Vui lòng nhập câu hỏi của bạn",
    "submitConfirm": " Bạn có chắc chắn muốn gửi bài kiểm tra nhanh này không?",
    "noLive": "Chưa có khóa học trực tiếp nào.",
    "PleaseLogin": "Xin hãy đăng nhập",
    "submitHint": "Bạn có chắc chắn muốn gửi bảng câu hỏi này không? ",
    "nonull": "Đang tồn tại mục chưa được nhập thông tin trong bản khảo sát",
    "nocorrect": "Bạn không thể làm lại bài thi khi đang chấm điểm bài thi. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn tất.",
    "mostPage": " Đã bị vượt quá số trang tối đa.",
    "leastPage": " Đã bị vượt quá số trang tối thiểu.",
    "saveNotes": "Xác nhận:Lưu Ghi chú",
    "unSaveNotes": "Hủy:Không lưu ghi chú",
    "dontSave": "Không lưu ghi chú.",
    "wordMore": "Đã vượt quá số ký tự tối đa có thể nhập.",
    "saveSuccess": "Đã lưu.",
    "PleaseLogin": "Vui lòng đăng nhập để sử dụng dịch vụ này.",
    "nonull": "Có các mục chưa được trả lời. Vui lòng trả lời tất cả các mục.",
    "systemError": "Đã xảy ra lỗi hệ thống.",
    "userNotExist": "Người dùng không tồn tại.",
    "passwordWrong": "Mật khẩu không đúng.",
    "passErrorTimer": "Mật khẩu đã bị sai 5 lần. Tài khoản sẽ bị khóa trong 10 phút",
    "passLock": "Tài khoản đang bị khóa trong 10 phút. Xin hãy xác nhận lại sau.",
    "failMatch": "Không thể phát hiện khuôn mặt. Vui lòng kiểm tra hướng và cài đặt của camera.",
    "faceFail": "Không nhận dạng được khuôn mặt.",
    "AccecpProtocol": "Vui lòng đọc và đồng ý với chính sách bảo mật.",
    "submitConfirmTest": "Bạn có chắc chắn muốn gửi bài kiểm tra cuối kỳ không? ",
    "submitConfirmExam": "Bạn có chắc chắn muốn gửi bài kiểm tra giữa kỳ không?",
    "submitSuccessExam": "Đã nộp bài kiểm tra giữa kỳ. Nhấp vào” Thành tích ”để kiểm tra kết quả.",
    "submitSuccessTest": "Đã nộp bài kiểm tra cuối kỳ. Nhấp vào” Thành tích ”để kiểm tra kết quả. ",
    "submitSuccessTask": "Đã gửi bài kiểm tra nhanh. Vui lòng kiểm tra kết quả trong” Tỷ lệ điểm ”. ",
    "uncheckMessage":"Một số cam kết chưa được chọn. Vui lòng kiểm tra và gửi lại.",
    "networkErr":"Lỗi kết nối mạng.",
    "confirmSaveNotes": "Ghi chú của bạn đã thay đổi. Bạn có muốn lưu lại ghi chú hiện tại hay không ?",
    "confirmJoinCourseOnline": "Bạn có muốn tham gia khóa học này không ?",
    "alertCourseOnlineEnd": "Xin lỗi khóa học này đã kết thúc.",
    "exerciseMsg": "Bạn có chắc chắn muốn nộp bài luyện tập không ?",
    "commonCourseMessage":"Đang học khoá học global「{1}」 của khoá học hiện tại.Khi bắt đầu học khoá học hiện tại, kết quả học tập của khoá học global 「{2}」 đã học sẽ bị xoá. Bạn có đồng ý không?",
    "downloadPdfFalse": "Tải xuống hóa đơn thất bạn. Bạn cần đăng ký lại khóa học để tiến hành xuất hóa đơn",
    "registerApplyCourseFalse": "Đăng ký khóa học không thành công. Bạn cần đăng ký lại khóa học để tiến hành xuất hóa đơn."
  },
  "new": {
    "title1": "Khóa học được đề xuất",
    "title2": "Cài đặt",
    "title3": "Xem thêm",
    "title4": "Thay đổi khóa học",
    "title5": "kết quả tìm kiếm",
    "title6": "Tất cả",
    "title7": "Kết thúc",
    "title8": "Đang dạy",
    "title9": "Chưa bắt đầu",
    "title10": "Chọn tất cả",
    "title11": "Bỏ chọn tất cả",
    "title12": "Xuất ghi chú",
    "title13": "Danh sách sự cố",
    "title14": "Tổng số câu hỏi",
    "title15": "Số câu trả lời",
    "title16": "Thời gian sử dụng",
    "title17": "Cảnh báo <br> Đang sử dụng mật khẩu mặc định! Vui lòng thay đổi mật khẩu để bảo mật.",
    "title18": "Mật khẩu mới bạn đã nhập giống với mật khẩu hiện tại.",
    "title19": "Tiến độ khoá học",
    "title20": "Bắt đầu học",
    "title21": "Khoá học đã kết thúc",
    "title22": "Nội dung học",
    "showCompletedCourse": "Gồm cả khóa học đã hoàn thành",
    "title24": "Điểm tối đa",
    "title25": "Chỉnh sửa",
    "title26": "Xin lỗi, vì bạn chưa thi nên không thể xác nhận điểm của mình.",
    "title27": "Bạn không thể kiểm tra điểm của mình trong khi chấm điểm bài kiểm tra. Vui lòng đợi một lúc cho đến khi việc chấm điểm hoàn thành.",
    "title28": "Mật khẩu hiện tại là mục nhập bắt buộc.",
    "title30": "Không thể bỏ qua các trang trong khi học",
    "title31": "Thoát",
    "title32": "Bạn có chắc chắn muốn thoát không?",
    "title33": "Bảng câu hỏi",
    "title34": "Yêu cầu",
    "title35": "Gửi yêu cầu chấm dứt. Bạn có chắc chắn không?",
    "title36": "Đã gửi yêu cầu kết thúc. Nhấp lại vào” Yêu cầu kết thúc ”để kiểm tra kết quả đơn đăng ký. ",
    "title37": "Bạn có chắc chắn muốn thi lại không?",
    "title38": "(* Đậu hay rớt sẽ được đánh giá dựa trên điểm của bài thi cuối kỳ)",
    "title39": "Di chuyển",
    "title40": "Khóa học chưa bắt đầu. Vui lòng đợi một lúc cho đến khi bắt đầu khóa học.",
    "title41": "Không thể truy cập vì ngoài thời gian hiệu lực của khóa học. Vui lòng liên hệ với quản trị viên.",
    "title42": "Có câu hỏi chưa được trả lời. Bạn có chắc chắn muốn gửi không? ",
    "title43": "Mật khẩu đã được sửa đổi thành công, vui lòng đăng nhập lại.",
    "title44": "Thời gian hiệu lực",
    "title45": "Không có",
    "title46": "Vui lòng gửi cam kết trước khi khảo sát",
    "title47": "Vui lòng hoàn thành khóa học trước khi khảo sát.",
    "title48": "Vui lòng trả lời “ bảng cam kết ”sau khi hoàn thành “ kỳ thi cuối khóa ”.",
    "title49": "Vui lòng hoàn thành khóa học trước khi gửi bản cam kết.",
    "title50": "Xác nhận tiến độ",
    "title51": "Tên học viên",
    "title52": "Chi nhánh",
    "title53": "Tổ chức trực thuộc",
    "title53_1": "Lớp học thêm",
    "title54": "Chi nhánh",
    "title54_1": "Lớp học trực thuộc",
    "title55": "Ngày rời khóa học",
    "title56": "Phân loại khóa học",
    "title57": "Tiến độ học tập",
    "title58": "Điểm thi mới nhất",
    "title59": "Đánh giá cuối kỳ",
    "title60": "Ngày bắt đầu",
    "title61": "Ngày kết thúc",
    "title62": "Số chương đã học",
    "title63": "Số chương chưa học",
    "title64": "Bản cam kết",
    "title65": "Bảng khảo sát",
    "title66": "Yêu cầu kết thúc",
    "title67": "Bao gồm cả học viên đã rời khóa học",
    "title68": "Tiến trình học tập của học viên",
    "title69": "Vui lòng nhập tên học viên.",
    "title70": "Xuất tệp EXCEL",
    "title71": "Vui lòng chọn một tổ chức sử dụng.",
    "title72": "Vui lòng chọn chi nhánh.",
    "title73": "Vui lòng chọn một loại khóa học.",
    "title74": "Từ 0",
    "title75": "Lên đến 100",
    "title76": "Vui lòng chọn đánh giá cuối kỳ.",
    "title77": "Phạm vi tiến độ",
    "title78": "Vui lòng chọn một yêu cầu kết thúc.",
    "title79": "Xuất file",
    "title80": "Hãy chọn khu vực trực thuộc",
    "title81": "Khóa học vẫn chưa được mở. Có thể nội dung sẽ bị thay đổi, nên chưa thể bắt đầu [Kì thi kết thúc]. Xin hãy chờ cho đến khi khóa học được mở khoá.",
    "title82": "Khóa học vẫn chưa được mở. Có thể nội dung sẽ bị thay đổi, nên chưa thể bắt đầu [Bảng khảo sát]. Xin hãy chờ cho đến khi khóa học được mở khoá.",
    "title83": "Khóa học vẫn chưa được mở. Có thể nội dung sẽ bị thay đổi, nên chưa thể bắt đầu [Bản cam kết]. Xin hãy chờ cho đến khi khóa học được mở khoá.",
    "title85": "Làm mới",
    "title86": "Thông báo",
    "title87": "Bạn phải xem xong video này trước khi qua trang khác !",
    "title88": "Không có nội dung trong bài học này !",
    "title89": "Nội dung này hiện chưa xem được, xin vui lòng quay lại sau !",
    "title90": "Vì bạn không phải là giáo viện phụ trách bài học này nên bạn không được phép xem thông tin tiết !",
    "title91": "Khóa học phụ thuộc {0} của bài học này chưa được hoàn thành và tạm thời không thể truy cập khóa học này!",
    "title92": "Vui lòng bắt đầu học sau {1} ngày sau khi kết thúc khóa học phụ thuộc {0} của khóa học này.",
    "title93": "Xin lỗi, bạn chưa thể truy cập trang này vì chưa có khóa học nào do bạn phụ trách!",
    "title94": "Xin lỗi, học viên này chưa tham gia khóa học nên bạn không thể xem thông tin chi tiết!",
    "title95": "Ngày hiện tại",
    "title96": "Xin lỗi, chưa có bài thi giữa kì nào. Vui lòng quay lại sau!",
    "title97": "Không thể làm bài thi giữa kì vì bạn đang làm bài thi cuối kì!",
    "title98": "Không thể làm bài thi cuối kì vì bạn đang làm bài thi giữa kì!",
    "title99": "Đang làm bài thi cuối kì, bạn có muốn vào thi tiếp?",
    "title100": "Đang làm bài thi giữa kì, bạn có muốn vào thi tiếp?",
    "title101": "Bạn đang làm một bài thi giữa kỳ khác. Vui lòng hoàn thành trước khi bắt đầu bài thi giữa kỳ này!",
    "title102": "Xin lỗi, bạn chưa thực hiện được bài thi vì chưa có câu hỏi trong bài thi này!",
    "title103": "Câu trả lời sai",
    "title104": "Không thể làm bài tập vì bạn chưa hoàn thành nội dung bài học này.",
    "title105": "Bạn không thể thi cuối kỳ vì bài tập của bạn không đạt tỷ lệ đậu.",
    "title106": "Không thể bắt đầu khóa học vì bạn không phải là học viên của khóa học này.",
    "title107": "Không thể kết thúc khóa học vì bạn không phải là học viên của khóa học này.",
    "title108": "Vì khóa học chưa có nội dung nên bạn không thể xem thông tin chi tiết !",
    "title109": "Tài khoản này đã bị vô hiệu!",
    "title110": "Vì bạn không phải là học viên của khóa học nên không thể kết thúc !",
    "title111": "TIẾN TRÌNH HỌC TẬP_",
    "title112": "Xin lỗi, học viên này chưa tham gia bài thi nào nên không thể xuất thành tích !",
    "title113": "Xin lỗi, không có học viên nào tham gia bài thi trong khóa học này nên không thể xuất thành tích !",
    "title114": "Xin lỗi, học viên này chưa được cài đặt là học viên của bất kỳ khóa học online nào nên không thể xuất thông tin chuyên cần!",
    "title115": "Danh sách câu hỏi",
    "title116": "Danh sách",
    "title117": "Khoá học được yêu thích",
    "title118": "Được nhiều học viên lựa chọn",
    "title119": "Mới nhất có thể đăng kí học",
    "title120": "Được khuyến khích bởi Study-Arts",
    "title121": "VNĐ",
    "title122": "Bạn đã hoàn thành bài thi với số điểm là",
    "title123": "Chi tiết câu sai",
    "title124": "Xác nhận",
    "title125": "Bài thi đang được chấm điểm, hãy xem điểm bằng cách bấm nút [Thành tích] sau khi bài thi được chấm điểm xong",
    "title126": "Số câu xem lại",
    "title127": "Cần xem lại",
    "title128": "Danh sách xem lại",
    "title129": "Hiển thị",
    "title130": "Khoá học mới nhất",
    "title131": "Được nhiều học viên lựa chọn",
    "title132": "Khuyến khích bởi Study-Arts",
    "title133": "Khoá học theo danh mục",
    "title134": "Sắp xếp",
    "title135": "Học nhiều nhất",
    "title136": "Đánh giá cao nhất",
    "title137": "Giá thấp đến cao",
    "title138": "Giá cao đến thấp",
    "title139": "Mới nhất",
    "title140": "Sắp xếp khoá học",
    "title141": "học viên",
    "title142": "Thêm vào giỏ hàng",
    "title143": "Đăng kí khóa học",
    "title144": "Học trọn gói với",
    "title145": "Thời gian học dự kiến",
    "title146": "Giờ",
    "title147": "Giáo trình",
    "title148": "Thời hạn giảm giá",
    "title149": "Số học viên hiện tại",
    "title150": "Nội dung khóa học",
    "title151": "Mục lục khóa học",
    "title152": "Giỏ hàng trống",
    "title153": "Giá khóa học",
    "title154": "Bài",
    "title155": "Tổng tiền",
    "title156": "Khoá học liên quan",
    "title157": "Khóa học này đã có trong giỏ hàng của bạn!",
    "title158": "Nhận xét của học viên",
    "title159": "Thêm đánh giá của bạn về khóa học",
    "title160": "Đánh giá của bạn về khóa học này",
    "title161": "Gửi đánh giá",
    "title162": "Đăng ký",
    "title163": "Vào học",
    "title164": "Chuyển khoản",
    "title165": "Thông tin chuyển khoản",
    "title166": "Số tài khoản",
    "title167": "Tên ngân hàng",
    "title168": "Số tiền",
    "title169": "Nội dung chuyển khoản",
    "title170": "Họ và tên",
    "title171": "Mail/UserID",
    "title172": "Số điện thoại",
    "title173": "Chú ý: bạn cần ghi chú lại nội dung chuyển khoản để dùng khi liên hệ với nhân viên Study-arts về nội dung đăng kí học",
    "title174": "Thông tin khóa học đã đăng ký",
    "title175": "Giá gốc",
    "title176": "Số tiền đã giảm",
    "title177": "Số tiền phải trả",
    "title178": "Đăng ký thành công",
    "title179": "Bạn đã đăng ký thành công khóa học trên Study-arts. Ngay sau khi kiểm tra được thông tin, chúng tôi sẽ gửi mail cung cấp thông tin đăng nhập cho bạn.",
    "title180": "Bạn hãy lưu lại mã chuyển khoản (nội dung chuyển khoản) đế có thể quản lý thông tin sau này.",
    "title181": "Quay lại trang khóa học",
    "title182": "Đăng kí khoá học",
    "title183": "Đăng kí học",
    "title184": "Xin lỗi, chưa có học viên tham gia khóa học nên không thể xuất thông tin chuyên cần.",
    "title185": "Không thể xuất file vì không có dữ liệu.",
    "title186": "Khóa học HOT",
    "title187": "Bạn sẽ phải làm bài lại từ đầu vì bạn đã làm bài trên thiết bị khác.",
    "title188": "Nếu bạn vẫn muốn làm bài thi trên thiết bị này thì phải làm bài lại từ đầu.",
    "title189": "Danh mục khóa học",
    "title190": "Danh mục chung",
    "title191": "Bài làm của bạn gửi đi không thành công. Vui lòng kiểm tra lại kết nối mạng. Hoặc có thể liên hệ trực tiếp với chúng tôi.",
    "title192": "Đã tồn tại khóa học tương ứng trong lịch trình. Hãy kiểm tra lại khóa học lịch trình.",
    "title193": "Danh sách câu trả lời sai",
    "title194": "Không có câu trả lời sai của học viên trong lần thi gần nhất!",
    "title195": "Bạn đã thêm khóa học này vào giỏ hàng.",
    "title196": "Tiếp tục mua",
    "title197": "Chưa có đánh giá nào về khóa học!",
    "title198": "Hãy nhập nội dung đánh giá.",
    "title199": "Hãy nhập họ và tên.",
    "title200": "Hãy nhập Mail.",
    "title201": "Hãy nhập số điện thoại.",
    "title202": "Vui lòng nhập đúng định dạng số điện thoại.",
    "title203": "Ẩn bớt",
    "title204": "Mã chuyển khoản",
    "title205": "Số tiền cần chuyển khoản",
    "title206": "Xuất thông tin đăng kí",
    "title207": "Lưu khoá học",
    "title208": "X",
    "title209": "Không còn câu trả lời sai trong danh sách!",
    "title210": "Nếu bạn thay đổi trình duyệt hoặc thiết bị khi đang làm bài thi, thì nội dung đã làm sẽ không được lưu.",
    "title211": "Khóa học lựa chọn",
    "title212": "Giới thiệu về khóa học",
    "title213": "Giới thiệu về giáo viên",
    "title214": "Miễn phí",
    "title215": "Khóa học miễn phí",
    "title216": "Vui lòng trả lời “ bảng cam kết ”sau khi hoàn thành “ kỳ thi cuối khóa ”.",
    "title217": "Vui lòng đánh dấu vào ô xác nhận nội dung của bảng khảo sát trước khi gửi.",
    "title218": "Bạn có muốn điểm danh cho học viên này không ?",
    "title219": "Lưu ý",
    "title220": "Khoá học nổi bật",
    "title221": "Tất cả danh mục",
    "title222": "Khoá học đã hoàn thành",
    "title223": "Tài khoản",
    "title224": "Khóa học đã chọn",
    "title225": "Tìm thêm khóa học",
    "title226": "Ngân hàng khác",
    "title227": "Sắp xếp theo",
    "title228": "Xác nhận đăng ký",
    "title229": "Bỏ chọn",
    "title230": "Họ và tên",
    "title231": "Ẩn danh",
    "title232": "Hãy viết đánh giá của bạn vào đây.",
    "title233": "Study-Arts",
    "title234": "Xác nhận Mail/UserID.",
    "title235": "Mail và Mail xác nhận không trùng khớp.",
    "title236": "Chấp nhận liên kết",
    "title237": "Từ chối liên kết",
    "title238": "Chấp nhận",
    "title239": "Từ chối",
    "title240": "Xem trước",
    "title241": "Vui lòng nhập đúng định dạng họ và tên.",
    "title242": "Vui lòng nhập đúng định dạng Mail.",
    "title243": "Mail đã tồn tại trong hệ thống. Vui lòng sử dụng Mail khác hoặc đăng nhập vào Mail hiện tại để tiếp tục quá trình đăng kí khoá học.",
    "title244": "Khoá học này đã được đăng ký.",
    "title245": "Hãy nhập Mail xác nhận.",
    "title246": "Mail",
    "title247": "Xác nhận Mail.",
    "title248": "Không",
    "title249": "Vui lòng điền vào các mục bắt buộc nhập ( nền màu hồng nhạt ) và gửi lại.",
    "title250": "Chúng tôi đã nhận được đăng ký khóa học trực tuyến StudyArts của bạn. Vui lòng xác nhận thông tin đăng ký dưới đây, chọn ngân hàng và tải xuống hóa đơn.",
    "title251": "Vui lòng thanh toán hóa đơn đúng hướng dẫn, chúng tôi rất mong sớm nhận được thanh toán của bạn. Sau khi thanh toán hoàn tất, chúng tôi sẽ gửi thông tin đăng nhập cho bạn qua email.",
    "title252": "Họ và tên:",
    "title253": "Email:",
    "title254": "Ngân hàng:",
    "title255": "Số tài khoản:",
    "title256": "Tên tài khoản:",
    "title257": "Tải xuống hoá đơn",
    "title258": "地域番号",
    "title259": "様",
    "title260": "発行日",
    "title261": "年",
    "title262": "月",
    "title263": "日",
    "title264": "学費請求書",
    "title265": "ご請求金額",
    "title266": "項目",
    "title267": "金額",
    "title268": "コース期間",
    "title269": "①　次のいずれかの支払い方法を選択してください",
    "title270": "WeChat 支払い: WeChat で次の QR コードをスキャンし、この支払い通知をアップロードし、",
    "title285": "送金 者に関する情報を入力してください。リアルタイム為替レート、手数料 1.3%。",
    "title271": "②　海外送金：銀行経由で下記の学校口座に送金してください。",
    "title272": "Đồng",
    "title273": "Ngân Hàng:",
    "title274": "Xác nhận thông tin đăng kí",
    "title275": "Vui lòng kiểm tra thông tin đăng ký dưới đây.",
    "title276": "Vui lòng xác nhận thông tin đăng ký dưới đây và chọn khu vực đăng ký trước khi thực hiện đăng ký.",
    "title277": "申込番号",
    "title278": "内訳",
    "title279": "※海外送金に必要な振込手数料は送金者のご負担となります。",
    "title280": "修正不可",
    "title281": "※請求書についてご質問があれば、電話にて下記までお問合せ下さい。",
    "title282": "お問い合わせ番号：",
    "title283": "Tên khóa học: ",
    "title284": "Các khóa học bạn đăng ký lần này bao gồm các khóa học đã đăng ký trước đó, vui lòng kiểm tra lại xem khóa học bạn đăng ký có sai sót gì không. ",
    "title290": "Nếu không có vấn đề gì sau khi xác minh và bạn muốn đăng ký như hiện tại, vui lòng nhấp vào nút 「Đồng ý」.",
    "title289": "Tuy nhiên, xin lưu ý rằng thông tin đăng ký trước đây cho khóa học này sẽ bị ghi đè.",
    "title286": "Đồng ý",
    "title287": "Hủy",
    "title288": "オンライン授業請求書_",
    "title291": "Miễn phí",
    "title292": "Đăng ký",
    "title293": "Xác nhận đăng ký",
    "title294": "Xuất tiến độ học tập"
  },
  "manage": {
    "look": "Hiển thị",
    "discription": "Giới thiệu",
    "students": "Danh sách học viên",
    "lessons": "Danh sách khóa học",
    "detail": "Thông tin chi tiết",
    "student": "Thông tin học viên",
    "lesson": "Thông tin khóa học",
    "questions": "Danh sách bài tập",
    "sex": "Giới tính",
    "lesson_begin": "Khóa học chưa bắt đầu",
    "lesson_learning": "Khóa học đang học",
    "lesson_end": "Khóa học đã kết thúc",
    "default": "Tất cả khóa học",
    "manage_info": "Quản lý thông tin",
    "download": "Tải về",
    "coursesOnline": "Số học viên",
    "downloadStudents": "Xuất danh sách học viên",
    "attendance": "Thông tin điểm danh",
    "presentList": "Danh sách học viên có mặt",
    "absentList": "Danh sách học viên vắng",
    "statusAttendance": "Trạng thái tham gia",
    "present": "Có mặt",
    "absent": "Vắng mặt"
  },
  "manage_questions": {
    "questions_id": "Nhập ID câu hỏi",
    "questions_content_title": "Nội dung câu hỏi",
    "questions_audio": "Âm thanh",
    "questions_video": "Video",
    "questions_image": "Hình ảnh",
    "questions_created": "Tôi đã tạo",
    "chosse_questions": "Chọn hình thức câu hỏi",
    "chosse_questions_one": "Câu hỏi lựa chọn một đáp án",
    "chosse_questions_more": "Câu hỏi lựa chọn nhiều đáp án",
    "questions_writing": "Câu hỏi viết câu trả lời",
    "chosse_answer_more": "Nhiều câu hỏi",
    "chosse_status_questions": "Chọn loại câu hỏi",
    "questions_exercise": "Câu hỏi bài tập",
    "questions_test": "Câu hỏi bài thi",
    "chosse_teacher_create": "Chọn giáo viên đã tạo câu hỏi",
    "chosse_chapter": "Chọn chương cần tìm",
  },
  "live_lesson": {
    "hiden": "Ẩn khung tìm kiếm",
    "display": "Hiển thị khung tìm kiếm",
  },
  "profile": {
    "name": "Tên học viên",
    "sex": "Giới tính",
    "email": "Email",
    "statistic": "Thống kê",
    "sum_lesson": "Tổng số khóa học",
    "lesson_begin": "Số khóa học chưa bắt đầu",
    "lesson_learning": "Số khóa học đang học",
    "lesson_end": "Số khóa học đã kết thúc",
    "detail_lesson": "Chi tiết khóa học",
    "course": "khóa",
    "discription": "Giới thiệu",
    "link": "Đường dẫn liên kết",
    "studyTime": "Thời gian tham gia",
    "showStatical": "Hiển thị thống kê",
    "jonhLiveCourse": "Số lần tham gia học online",
    "noJonhLiveCourse": "Số lần không tham gia học online",
  },
  "manage_lesson": {
    "keyWord": "Nhập tiêu đề khoá học",
    "lesson": "Bài học",
    "lesson_list": "Mục lục khoá học",
    "total_lesson": "Tổng số bài học",
    "total_excercise": "Tổng số bài tập",
    "total_student": "Tổng số học viên tham gia khoá học",
    "statistical": "Thống kê",
    "time_course": "Thời gian khoá học",
    "teacher_charge": "Giáo viên phụ trách",
    "status_course": "Trạng thái khoá học",
    "live_lesson": "Đang học",
    "not_stater": "Chưa bắt đầu",
    "not_open": "Tạm thời chưa mở",
    "next_page_details": "Nội dung chi tiết",
    "info_course": "Thông tin khoá học",
    "status1": "Học viên chưa học",
    "status2": "Học viên đang học",
    "status3": "Học viên đã học xong",
    "clear": "Tìm kiếm mặc định",
    "choose_date": "Chọn ngày tạo câu hỏi",
    "static": "Thành tích thi",
  },
  "manage_student": {
    "lesson_normal": "khóa học để học",
    "lesson_test": "bài kiểm tra",
    "type": "Loại",
    "time": "Thời gian",
    "count_of_students": "Số lượng học viên",
    "teacher": "Giáo viên",
    "job": "Vai trò",
    "mobile": "Thông tin liên lạc",
    "to_chuc": "Tổ chức sử dụng",
    "level": "Cấp",
    "age": "Ngày tháng năm sinh",
    "area": "Quốc gia (ngôn ngữ)",
    "chi_nhanh": "Lớp học trực thuộc",
    "male": "Nam",
    "female": "Nữ",
    "charge": "Khóa học phụ trách",
    "not_charge": "Khóa học không phụ trách",
    "status": "Trạng thái",
    "person_charge": "Người phụ trách",
    "me": "Tôi",
    "not_me": "Không phải tôi",
    "lesson_unlocked": "Chưa tham gia học",
    "lesson_locked_not_study_end": "Đang tham gia học",
    "lesson_study_end_not_exam": "Đã học xong nội dung bài học",
    "lesson_exam_doing": "Đang đợi chấm điểm thi cuối kỳ",
    "lesson_exam_end": "Chưa chấm điểm",
    "lesson_unpass": "Không đậu",
    "lesson_pass": "Đậu",
    "lesson_tuyet_doi": "Điểm tuyệt đối",
    "lesson_end": "Đã kết thúc khóa học",
    "app_sp": "ứng dụng và hỗ trợ",
    "keyWord": "Nhập tiêu đề hoặc nội dung khóa học",
    "exam_not_me": "Người dùng không phải là học viên của khóa học",
    "live_time": "Thời gian trực tuyến",
    "hour": "giờ",
    "minute": "phút",
    "export": "Xuất thành tích học viên",
    "exportDiligent": "Xuất thông tin chuyên cần",
    "noJonhLive": "Không tham gia",
  },
  "statictical" : {
    "chapter_status": "Trạng thái bài học",
    "total_chapter": "Tổng số bài học",
    "excercise_status": "Trạng thái bài tập",
    "total_excersice": "Tổng số bài tập",
    "completed": "Học xong",
    "unstudied": "Chưa học",
    "studying": "Đang học",
    "scored": "Đã chấm bài",
    "unscored": "Chưa làm bài",
    "waiting_scoring": "Đang đợi chấm bài",
  },
  "mid_term": {
    "mid_term": "Bài thi giữa kì",
    "choose_mid_term": "Chọn bài thi giữa kì",
  },
  "wrong_book": {
    "examList": "Danh sách kỳ thi"
  },
  "preview": {
    "examList": "Xem trước danh sách kỳ thi"
  },
  "comments": {
    "commentName": "Danh sách trao đổi",
    "titleStatus": "Gồm cả những trao đổi trong các khóa chưa tham gia",
    "content": "Nội dung liên quan",
    "countConv": "Số trao đổi",
    "timeSeen": "Thời gian xem cuối",
    "detail": "Chi tiết"
  },
  "courseOnline": {
    "timeCourse": "Thời gian diễn ra tiết học",
    "comingSoon": "Sắp bắt đầu",
    "title1": "Khóa học bạn đang muốn tham gia là XXXXX.",
    "title2": "Khóa học này còn XX phút nữa mới bắt đầu.",
    "title4": "Bạn có muốn tham gia khóa học này không ?",
    "attendance": "Khóa học đã kết thúc, nếu tạm chuyển sang ca học khác và đã học xong. Bạn có thể [ XXX ] lại cho khóa học này.",
    "comfirmRejoin": "Bạn có muốn vào lại phòng học hay không ?",
    "join": "Điểm danh",
    "reBegin": "Vào lại phòng",
    "joinSuccess": "Điểm danh vào khóa học thành công",
    "joinError": "Điểm danh vào khóa học không thành công",
    "btitle1": "Bạn hãy nhấn vào [XXX] để vào phòng học.",
    "btitle2": "Nếu ứng dụng học online không được mở bạn nhấn vào [XXX]",
    "btitle3": "Chú ý với cách truy cập này bạn sẽ không được điểm danh nên sau khóa học bạn hãy vào tự điểm danh cho mình.",
    "draft": "Dự phòng",
    "courseName": "Tiết học",
    "courseNameInput": "Vui lòng nhập tên tiết học",
    "quantityAlert": "Bạn không thể tham gia khóa học vì đã đủ số người tham gia"
  },
  "notification": {
    "title1": "Đây là thông báo trong khóa học bạn chưa bắt đầu học.",
    "title2": "Bạn có muốn bắt đầu khóa học để xem nội dung thông báo hay không ?",
    "common": "Bạn nhận được thông báo mới",
  },
  "scoreStaticNew": {
    "noInformation": "Chưa có dữ liệu thi của học viên này",
    "timeExamStart": "Thời gian bắt đầu thi",
    "timeExamEnd": "Thời gian kết thúc thi",
    "timeExamConducted": "Thời gian làm bài thi(phút)",
    "examDate": "Ngày bắt đầu thi",
    "timeExamConductedNew": "Thời gian làm bài thi",
  }, 
  "manual": {
    "changeLanguage": "Thay đổi ngôn ngữ",
    "searchCourse": "Tìm kiếm khóa học",
    "personalInfo": "Thông tin cá nhân",
    "forgotPass": "Quên mật khẩu",
    "changeAva": "Thay đổi ảnh đại diện",
    "changeInfo": "Thay đổi thông tin cá nhân",
    "changePass": "Thay đổi mật khẩu",
    "commentNoti": "Thông báo trao đổi mới",
    "participation": "Tham gia khóa học",
    "exercise": "Bài luyện tập",
    "markExercise": "Điểm bài luyện tập",
    "midTerm": "Bài thi giữa kỳ",
    "finalExam": "Bài thi cuối kỳ",
    "achievements": "Kiểm tra thành tích",
    "wrongList": "Danh sách câu trả lời sai",
    "general": "Chung",
    "endCourse": "Kết thúc khóa học",
    "achievementStudent": "Thành tích của học viên",
    "settingProcedure": "Hướng dẫn cài đặt",
    "pwa": "Sử dụng trên điện thoại",
    "infoAcc": "Thông tin tài khoản",
    "jonhExam": "Tham gia thi",
  },
  "scoreNew": {
    "title1": "Điểm từng mục đạt được",
    "title2": "Tỷ lệ câu đúng",
    "title3": "Tỷ lệ điểm",
    "title4": "Tên bài học",
    "title5": "Tổng số câu",
    "title6": "Số câu làm đúng",
    "title7": "Số câu làm sai",
    "title8": "Điểm đạt được",
    "title9": "Xuất thành tích thi",
    "title10": "Chi tiết thi",
  },
  "manualNew": {
    "type_1": "Cho người sử dụng lần đầu",
    "type_1_1": "Dùng trên máy tính",
    "type_1_2": "Dùng trên điện thoại・Tablet",
    "type_2": "Đăng nhập・Đăng xuất",
    "type_2_1": "Thay đổi ngôn ngữ",
    "type_2_2": "Đăng nhập",
    "type_2_3": "Quên mật khẩu",
    "type_2_4": "Đăng xuất",
    "type_3": "Tham gia khóa học",
    "type_3_1": "Tìm kiếm khóa học",
    "type_3_2": "Xem khóa học của tôi",
    "type_3_3": "Học nội dung",
    "type_3_4": "Thi giữa kỳ",
    "type_3_5": "Thi cuối kỳ",
    "type_3_6": "Xem thành tích thi",
    "type_3_7": "Làm bảng cam kết",
    "type_3_8": "Làm bảng khảo sát",
    "type_3_9": "Xuất file ghi chú",
    "type_3_10": "Yêu cầu kết thúc khóa học",
    "type_4": "Xem tiến độ học tập",
    "type_4_1": "Xem tình trạng khóa học",
    "type_4_2": "Xem thành tích học tập",
    "type_5": "Tham gia học online",
    "type_5_1": "Tìm kiếm lớp học",
    "type_5_2": "Tham gia lớp học",
    "type_6": "Thay đổi thông tin cá nhân",
    "type_6_1": "Thay đổi ảnh đại diện",
    "type_6_2": "Thay đổi thông tin",
    "type_6_3": "Thay đổi ngôn ngữ hệ thống",
    "type_6_4": "Thay đổi mật khẩu",
    "type_7": "Sử dụng chức năng quản lý",
    "type_7_1": "Xem tiến độ học của học viên",
    "type_7_2": "Quản lý học viên",
    "type_7_3": "Quản lý khóa học",
    "type_7_4": "Thông tin điểm danh",
    "type_7_5": "Khoá học online",
    "type_3_3_1": "♦ Bắt đầu khoá học",
    "type_3_3_2": "♦ Chọn bài học",
    "type_3_3_3": "♦ Di chuyển nội dung lên・xuống",
    "type_3_3_4": "♦ Phóng to/Thu nhỏ",
    "type_3_3_5": "♦ Ghi chú",
    "type_3_3_6": "♦ Trao đổi ý kiến",
    "type_3_3_7": "♦ Di chuyển trang",
    "type_3_3_8": "♦ Làm bài tập",
    "type_3_3_9": "♦ Xem điểm bài tập",
    "type_3_3_10": "♦ Quay về",
  },
  "codeStatus": {
    "code_1_99": "Không có data",
    "code_1_0": "Bình thường",
    "code_1_1": "Chưa bắt đầu",
    "code_1_2": "Ngoài thời gian hiệu lực",
    "code_1_3": "Khóa học đã có chưa hoàn thành",
    "code_1_4": "Khóa học có sẵn đã hoàn thành, nhưng không thỏa mãn số ngày có sẵn"
  },
  "online_ja": {
    "attendance1": "Vì khoá học online này đã kết thúc rồi nên không thể tham gia.",
    "attendance2": "Nếu muốn điểm danh  bằng tay, hãy nhấn nút 「XXX」",
    "attendance3": "Nếu muốn sử dụng lại phòng họp Web, hãy vào phòng họp này bằng cách nhấn nút 「XXX」",
    "join": "Tham gia",
    "cancel": "Huỷ",
    "rejoin": "Tham gia lại",
    "title": "Xác nhận",
    "title1": "Hãy tham gia khoá học bằng cách nhấn xuống 「XXX」",
    "title2": "Chú ý: Trường hợp không thể tham gia vì không mở được application của khoá học online, hãy tham gia trực tiếp không thông qua StudyArts bằng cách nhấn xuống nút 「XXX」. Tuy nhiên, trường hợp tham gia trực tiếp vì không lấy tỷ lệ chuyên cần tự động được nên hãy tính chuyên cần lại sau khi kết thúc khoá học online.",
    "draft": "Tham gia thẳng",
    "clickJump": "Tham gia",
  }

}
export default vi;



// WEBPACK FOOTER //
// ./src/assets/languages/vi.js